import { eventTracker } from 'app/modules/Segment';
import {
  TProperties,
  TContext,
  GroupIdEnum,
  OwnerEnum,
  FeatureEnum,
} from 'app/modules/Segment/types';
import { snakeCaseToTitleCase } from 'app/modules/Segment/utils';

const EVENTS = {
  CHECKOUT_SIGN_UP_ACCOUNT_CREATION_SUBMIT: 'sign_up_account_creation_submit',
} as const;

const GENERAL_LIBRARY_NAME = 'general-library';
const ONBOARDING_ACTIVATION_CATEGORY = 'onboarding_activation';

const cadastroCheckoutSegmentContext: TContext = {
  groupId: GroupIdEnum.GENERAL_GROUP,
  library: {
    name: GENERAL_LIBRARY_NAME,
    componente: 'creation-submit-component',
  },
};

export function trackSignUpAccountCreationSubmit(
  additionalProperties?: Record<string, unknown>,
): void {
  const event = EVENTS.CHECKOUT_SIGN_UP_ACCOUNT_CREATION_SUBMIT;

  const properties: TProperties = {
    ...(additionalProperties ?? {}),
    owner: OwnerEnum.PAGAMENTOS,
    feature: FeatureEnum.CHECKOUT,
    category: ONBOARDING_ACTIVATION_CATEGORY,
    event_meaning:
      '[Checkout] Preencheu formulário do step 2 do checkout e avançou para realizar pagamento',
    relevant_user_activity: true,
    event_text: snakeCaseToTitleCase(event),
  };

  eventTracker.track({
    event,
    properties,
    context: cadastroCheckoutSegmentContext,
  });
}
